var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"form-input-text-wrap"},[_c('IDateTime',{attrs:{"disabled":!_vm.IsWritable},model:{value:(_vm.formData[_vm.columnDefinition.name]),callback:function ($$v) {_vm.$set(_vm.formData, _vm.columnDefinition.name, $$v)},expression:"formData[columnDefinition.name]"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }